// Floating banner box set up

    function setBannerMargin() {
        var bannerBox_1 = document.getElementById('bannerBox');
        var banner = document.querySelector('.banner');
    
        var currentPath = window.location.pathname;
        var excludePaths = ['/account/login', '/account/register', '/pages/contact', 'pages/faq'];
        var excludeCondition = !excludePaths.includes(currentPath);
    
        if (bannerBox_1 && banner && window.innerWidth >= 990) {
            var bannerBoxHeight = bannerBox_1.clientHeight;
            if (window.location.pathname === '/pages/events') {
                banner.style.marginBottom = (bannerBoxHeight - 250) + 'px';
            } else {
                banner.style.marginBottom = (bannerBoxHeight - 100) + 'px';
            }
        } else if (bannerBox_1 && banner && window.innerWidth >= 750 && window.innerWidth < 990) {
            var bannerBoxHeight = bannerBox_1.clientHeight;
            banner.style.marginBottom = (bannerBoxHeight - 300) + 'px';
        } else if (bannerBox_1 && banner && window.innerWidth < 750 && excludeCondition) {
            var bannerBoxHeight = bannerBox_1.clientHeight;
            if (window.location.pathname === '/pages/gifting') {
                banner.style.marginBottom = (bannerBoxHeight - 280) + 'px';
            } else {
                banner.style.marginBottom = (bannerBoxHeight - 200) + 'px';
            }
        } else if (bannerBox_1 && banner && window.innerWidth < 750) {
            var bannerBoxHeight = bannerBox_1.clientHeight;
            banner.style.marginBottom = (bannerBoxHeight - 300) + 'px';
        }
    }
    
    window.addEventListener('load', setBannerMargin);

    //Contact page margin bottom adjustment
    document.addEventListener('DOMContentLoaded', function() {
        var iframe = document.querySelector('.contact-page iframe');
        var banner = document.querySelector('.contact-page .banner');
    
        function updateBannerMargin() {
            var iframeHeight = iframe.getAttribute('height');
            banner.style.marginBottom = iframeHeight + 'px';
        }
      
        var observer = new MutationObserver(function(mutationsList) {
            for (var mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'height') {
                    updateBannerMargin();
                }
            }
        });
    
        observer.observe(iframe, { attributes: true });
        updateBannerMargin();
    });
  
    //Twelve lessons page manually add subscription to cart
    // Function to check if the product is already in the cart
    function isProductInCart(productId, sellingPlan) {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                return cart.items.some(item => {
                    // Check if the variant ID and selling plan match
                    return item.variant_id === productId && 
                           item.selling_plan_allocation &&
                           item.selling_plan_allocation.selling_plan.id === sellingPlan;
                });
            });
    }
    
    // Function to add the product to the cart
    function addToCart() {
        var productId = 51727330509182;
        var quantity = 1;
        var sellingPlan = 690313330996;
    
        // Check if the product is already in the cart
        isProductInCart(productId, sellingPlan).then(isInCart => {
            if (isInCart) {
                alert('This product is already in your cart.');
            } else {
                // If not in the cart, add it to the cart
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: [
                            {
                                id: productId,
                                quantity: quantity,
                                selling_plan: sellingPlan
                            }
                        ]
                    })
                })
                .then(response => response.json())
                .then(data => {
                    window.location.href = '/cart';
                })
                .catch(error => {
                    console.error('Error:', error);
                });
            }
        });
    }

    
